<template>
  <div class="round-details">
    <div class="flex justify-center align-center">
      <RouterLink
        :disabled="!roundNav.prev"
        :to="roundNav.prev"
        tag="button"
        class="btn--link"
        aria-label="previous round"
      >
        <MtxSvg icon="icon-chevron-left" />
      </RouterLink>
      <h3 class="text-center mb-0 mx-2">Round {{ roundId }}</h3>
      <RouterLink
        :disabled="!roundNav.next"
        :to="roundNav.next"
        tag="button"
        class="btn--link"
        aria-label="next round"
      >
        <MtxSvg icon="icon-chevron-right" />
      </RouterLink>
    </div>

    <template v-if="!isLoading">
      <div class="text-center">{{ round.bounty | mtx }}</div>

      <template v-if="mySubmissions.length">
        <h4>My Submissions</h4>
        <SubmissionsList :submissions="mySubmissions" :key="'subs'" />
      </template>

      <div class="flex justify-between align-center flex-wrap mb-3">
        <h4>All Submissions</h4>

        <button
          v-if="isOwner && round.status === 'review'"
          @click="selectWinners = !selectWinners"
          :disabled="!Object.keys(selected).length"
          class="btn btn--link"
        >
          Select Winners
        </button>
      </div>

      <p v-if="!isOwner && round.status == 'open'">
        Submissions will be available when the round is over
      </p>
      <SubmissionsList
        v-else
        :key="'subs2'"
        :submissions="round.submissions"
        :selectable="isOwner && round.status === 'review'"
        @submissionToggled="onSubmissionToggled"
      />

      <MtxModal v-model="selectWinners" width="600px">
        <WinnerSelection
          :submissions="selected"
          :round="round"
          :mtxTournament="mtxTournament"
          @confirmed="selectWinners = false"
        />
      </MtxModal>
    </template>
    <template v-else>
      <div class="text-center mt-2">
        Loading round information...
      </div>
    </template>
  </div>
</template>

<script>
import SubmissionsList from "@/components/tournaments/SubmissionsList"
import WinnerSelection from "@/components/tournaments/WinnerSelection"
import API from "@/api"

export default {
  components: {
    SubmissionsList,
    WinnerSelection
  },

  props: {
    tournament: {
      type: Object,
      required: true
    },
    mtxTournament: Object
  },

  data: () => ({
    selectWinners: false,
    selected: [],
    round: null,
    isLoading: true,
    roundId: null
  }),

  computed: {
    isOwner() {
      return this.$store.state.user.ethAddress === this.tournament.owner
    },

    mySubmissions() {
      const me = this.$store.state.user.ethAddress
      return this.round.submissions.filter(s => s.owner === me)
    },

    roundNav() {
      const lastRound = this.tournament.round.index + 1
      const round = this.roundId

      const roundUrl = `/tournaments/${this.tournament.address}/round/`

      return {
        prev: round > 1 ? roundUrl + (round - 1) : "",
        next: round < lastRound ? roundUrl + (round + 1) : ""
      }
    }
  },

  watch: {
    "$route.params.roundId": {
      handler: "getRoundDetails",
      immediate: true
    }
  },

  methods: {
    async getRoundDetails(roundId) {
      this.isLoading = true

      const lastRound = this.tournament.round.index + 1
      this.roundId = +roundId

      if (roundId === undefined || +roundId > lastRound || +roundId <= 0) {
        return this.$router.replace({
          name: "TournamentsSingleRound",
          params: {
            roundId: lastRound.toString()
          }
        })
      }

      if (+roundId === lastRound) {
        this.round = this.tournament.round
      } else {
        const { success, data } = await API.getTournamentRound(
          this.tournament.address,
          +roundId - 1
        )

        if (success) {
          this.round = data.round
        }
      }

      this.isLoading = false
    },

    onSubmissionToggled(submission) {
      const index = this.selected.findIndex(sub => {
        return sub.hash === submission.hash
      })

      if (index >= 0) {
        this.selected.splice(index, 1)
        return
      }

      this.selected.push(submission)
    }
  }
}
</script>
